/**
 * Labstep
 *
 * @module core/MediaQuery/Desktop
 * @desc MediaQuery for Desktop
 */

import { MediaQuery } from 'labstep-web/core/MediaQuery';
import {
  type IMediaQueryProps,
  Size,
} from 'labstep-web/core/MediaQuery/types';
import type React from 'react';

type IMediaQueryDesktopProps = Omit<IMediaQueryProps, 'size'>;

export const MediaQueryDesktop: React.FC<IMediaQueryDesktopProps> = ({
  children,
}) => <MediaQuery size={Size.desktop}>{children}</MediaQuery>;
